import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Icon, Menu, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core'
import clsx from 'clsx'
import { gray } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	filterButton: {
		zIndex: 1
	},
	filterIcon: {
		fontSize: 19,
		color: gray[700],
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	check: {
		padding: 0,
		marginRight: 16,
		height: 18,
		width: 18,
		color: gray[500]
	},
	formLabel: {
		marginLeft: 0
	},
	summary: {
		minHeight: 54,
		'&.Mui-expanded': {
			minHeight: 54
		}
	},
	label: {
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		textTransform: 'capitalize'
	}
}))

/**
 *
 * @param {{
 * 	filters: string[],
 * 	onFiltersChanged: () => string[]
 * }} param0
 * @returns
 */
export const StyledSimpleFilter = ({ filters, onFiltersChanged }) => {
	const classes = useStyles()
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterMenuEl, setFilterMenuEl] = useState(null)
	const [availableFilters, setAvailableFilters] = useState([])
	const [selectedFilters, setSelectedFilters] = useState([])

	const handleClick = (event) => {
		setFilterMenuEl(event.currentTarget)
		setIsFilterOpen(true)
	}

	const handleFilterChange = (e) => {
		const filterValue = e?.target?.value || null
		if (!filterValue) {
			return
		}
		let newFilters = []
		if (selectedFilters.includes(filterValue)) {
			newFilters = selectedFilters.filter((v) => v !== filterValue)
		} else {
			newFilters = [...selectedFilters, filterValue]
		}

		setSelectedFilters(newFilters)
		if (onFiltersChanged) {
			onFiltersChanged(newFilters)
		}
	}

	useEffect(() => {
		if (filters) {
			setAvailableFilters(filters)
		}
	}, [filters])

	return (
		<div>
			<Button
				className={clsx(classes.headerButton, classes.filterButton)}
				onClick={handleClick}
				variant="outlined"
				size="large"
				classes={{
					label: classes.filterButtonLabel
				}}
				aria-controls="filter-menu"
				aria-haspopup="true">
				<Icon className={clsx(classes.filterIcon, 'fas fa-sliders-h')} /> {selectedFilters.length}
			</Button>
			<Menu
				open={isFilterOpen}
				id="filter-menu"
				anchorEl={filterMenuEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 30,
					horizontal: -280
				}}
				onClose={() => setIsFilterOpen(false)}
				MenuListProps={{
					style: {
						padding: 0
					}
				}}
				PaperProps={{
					style: {
						width: 339,
						borderRadius: 10,
						maxHeight: 454
					}
				}}>
				{availableFilters.map((filter, i) => {
					const selected = selectedFilters.includes(filter)
					return (
						<MenuItem className={classes.summary} key={`filter-${i}`}>
							<FormControlLabel
								className={classes.formLabel}
								classes={{
									label: classes.label
								}}
								control={
									<Checkbox
										checked={selected}
										className={classes.check}
										onChange={handleFilterChange}
										value={filter}
									/>
								}
								label={filter}
							/>
						</MenuItem>
					)
				})}
			</Menu>
		</div>
	)
}
